import * as React from 'react';

import {
  ApButtonMain,
  ApButtonSecondary,
  ApModal,
  ApTextInput,
} from '@alixpartners/ui-components';

import './InputModal.scss';

interface IInputModalProps {
  id: string;
  label: string;
  type?: 'input' | 'textarea';
  maxLength: number;
  isOpen: boolean;
  inputValue: string;
  initialInputValue: string;
  allowEmpty?: boolean;
  onModalClose: () => void;
  onInputValueChange: (event: React.FormEvent<Element>) => void;
  onSave: () => void;
}

const InputModal: React.FC<IInputModalProps> = ({
  id,
  isOpen,
  inputValue,
  initialInputValue,
  allowEmpty,
  onModalClose,
  onSave,
  onInputValueChange,
  label,
  type,
  maxLength,
}) => {
  const disabled = allowEmpty
    ? inputValue === initialInputValue
    : !inputValue || inputValue === initialInputValue;

  return (
    <ApModal
      className="input-modal"
      header={`Edit ${label}`}
      isDismissible
      isOpen={isOpen}
      hasClosed={onModalClose}
      footer={() => (
        <div className="input-modal__footer">
          <ApButtonSecondary onClick={onModalClose}>Cancel</ApButtonSecondary>
          <ApButtonMain onClick={onSave} disabled={disabled}>
            Apply
          </ApButtonMain>
        </div>
      )}
    >
      <div className="input-modal__content">
        <div className="input-modal__content__label">
          <div>{label}</div>
          <div>{`${inputValue.length}/${maxLength}`}</div>
        </div>
        {type === 'textarea' ? (
          <textarea
            id={`${id}-textarea`}
            className="input-modal__content__textarea"
            value={inputValue || ''}
            onChange={onInputValueChange}
          />
        ) : (
          <ApTextInput
            id={`${id}-input`}
            value={inputValue || ''}
            onChange={onInputValueChange}
          />
        )}
      </div>
    </ApModal>
  );
};

export default InputModal;
